<template>
  <div class="animated fadeIn">
    <Tables
      ref="tableGrid"
      :columns="[
        'ID',
        'Nome HSM',
        'Data Criação',
        'Texto HSM',
        $lang.Common.DataTable.Actions
      ]"
      :showNew="true"
      :showSearch="false"
      :showReload="true"
      :showTipFooter="false"
      v-on:New="onNew"
      v-on:Load="onLoad"
      v-on:Reload="onLoad"
    >
      <tr v-for="obj in this.objList" v-bind:key="obj.id">
        <TableColumn
          :IsText="true"
          v-on:Edit="onEdit(obj)"
          :status="obj.inative ? 0 : 1"
          :value="obj.hsmId ? obj.hsmId : '-'"
        />
        <TableColumn
          :IsText="true"
          v-on:Edit="onEdit(obj)"
          :status="obj.inative ? 0 : 1"
          :value="
            obj.hsmName
              ? obj.hsmName
              : '-'
          "
        />
        <TableColumn
          :IsDatetime="true"
          v-on:Edit="onEdit(obj)"
          :status="obj.inative ? 0 : 1"
          :value="obj.createdAt ? obj.createdAt : '-'"
        />
        <TableColumn
          :IsText="true"
          v-on:Edit="onEdit(obj)"
          :status="obj.inative ? 0 : 1"
          :value="
            obj.hsmText
              ? verificarTamanho(obj.hsmText)
              : ''
          "
        />
        <TableColumn
          :IsActionsButtons="true"
          :HasChange="false"
          v-on:Delete="onDelete(obj)"
          :status="obj.status"
        />
      </tr>
    </Tables>

    <div class="row">
      <div class="col-12 pb-3 pl-4">
        <button
          type="button"
          class="btn btn-third btn-sm"
          v-on:click="$emit('New')"
          v-b-tooltip.hover
          :title="'Clique para cadastrar'"
        >
          <i class="fas fa-user-plus"></i>
          <span class="d-md-down-none">&nbsp; Novo</span>
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import ActionsForm from '@/shared/mixins/actionsForm'
import { loading, toast } from '@/shared/utils/UIHelper'

import HsmRepository from '@/shared/http/repositories/configurations/hsm.js'

export default {
  name: 'ListaHsm',
  mixins: [ActionsForm],
  data () {
    return {
      filters: null
    }
  },
  methods: {
    onLoad () {
      this.onLoadAll()
      this.$eventHub.on('Filter', ({ filters }) => {
        this.filters = filters
        this.$refs.tableGrid.Clear()
        this.$nextTick(() => {
          this.onLoadAll()
        })
      })
    },
    onLoadAll () {
      loading.push()
      HsmRepository.GetAllPaging(this.$refs.tableGrid.pagingLimit, this.$refs.tableGrid.pagingIndex)
        .then(this.onResultGrid)
        .catch(this.onException)
    },
    onNew () {
      this.$emit('New')
    },
    onEdit (obj) {
      this.$emit('Edit', obj)
    },
    onDelete (obj) {
      loading.push()
      HsmRepository.Delete(obj.id)
        .then((response) => {
          loading.pop()
          toast.success(this.$lang.Common.Alerts.Success)
          this.onLoad()
        })
        .catch(this.onException)
    },
    createdAtEqualUpdatedAt (createdAt, updatedAt) {
      const date1 = new Date(createdAt)
      const date2 = new Date(updatedAt)

      if (date1.getTime() === date2.getTime()) {
        return ''
      }
      return updatedAt
    },
    verificarTamanho (texto) {
      if (texto.length <= 20) {
        return texto
      } else {
        return texto.slice(0, 97) + '...'
      }
    }

  }
}
</script>



// WEBPACK FOOTER //
// src/views/private/configurations/hsm/components/list/ListaHsm.vue